import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import SignInWithOtp from "@/components/auth/signin-with-otp";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";

export const Route = createFileRoute("/_public/auth/sign-in-with-otp")({
  component: SignInWithOtpPage,
});

function SignInWithOtpPage() {
  const navigate = useNavigate();
  // Igual que reset-password: el flujo OTP depende de RESEND en el backend.
  // Sin email configurado el código nunca llegaría, así que redirigimos.
  const emailEnabled = useQuery(
    api.system.onboarding.queries.isPasswordResetEmailEnabled,
  );

  useEffect(() => {
    if (emailEnabled === false) navigate({ to: "/auth/sign-in" });
  }, [emailEnabled, navigate]);

  const handleCancel = () => {
    navigate({ to: "/auth/sign-in" });
  };

  if (emailEnabled === false) return null;

  return (
    <div className="relative min-h-screen">
      <AuthLeftPanel
        headline="Entra con un código. Sin contraseña."
        subtitle="Te enviamos un código de un solo uso a tu correo. Sirve también cuando no recuerdas tu contraseña."
        badge=""
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        <SignInWithOtp handleCancel={handleCancel} provider="resend-otp" />
      </AuthRightPanel>
    </div>
  );
}